import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import useSeo from "../hooks/useSeo";
import useEnforceLightMode from "../hooks/useEnforceLightMode";
import { TOOLS, TOOLS_INDEX_SEO, toolPath } from "../seo/tools";
import { breadcrumbJsonLd } from "../seo/site";

export default function ToolsIndexPage() {
  useEnforceLightMode();
  useSeo({
    ...TOOLS_INDEX_SEO,
    jsonLd: [breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Free tools" }])],
  });

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-24 sm:pt-28 pb-16">
        <h1 className="text-3xl sm:text-4xl font-extrabold">Free clearance &amp; reseller tools</h1>
        <p className="mt-4 text-lg text-slate-600">{TOOLS_INDEX_SEO.description}</p>
        <ul className="mt-10 grid sm:grid-cols-2 gap-4">
          {TOOLS.map((t) => (
            <li key={t.slug}>
              <Link to={toolPath(t.slug)} className="flex h-full flex-col rounded-2xl border border-slate-200 p-5 hover:border-violet-300">
                <Wrench className="w-5 h-5 text-violet-700" />
                <span className="mt-3 text-lg font-bold">{t.navLabel}</span>
                <span className="mt-2 text-sm text-slate-600">{t.description}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
